// From https://www.regular-expressions.info/email.html
export const emailValidationPattern = new RegExp(
  /^\s*[a-zA-Z0-9.'_%+-]+@[a-zA-Z0-9.-]+\.[A-z]{2,}\s*$/
)
